$(document).ready(function () {
  let activeFilter = []
  $('.filters__tags-input').on('change', function () {
    if ($(this).prop( "checked" )){
      activeFilter.push($(this).val())
    }else {
      const index =   activeFilter.indexOf($(this).val())
      activeFilter.splice(index, 1)
    }
    if (activeFilter.length > 0) {
      $('.main-collection__product-list-item').removeClass('show')
      activeFilter.forEach(item => {
        $('.main-collection__product-list-item').each(function (index) {
          if ($(this).attr('data-tags-name').split(",").includes(item)) {
            $(this).addClass('show')
          }
        })
      })
    }else {
      $('.main-collection__product-list-item').addClass('show')
    }
  })
  $('body').on('click',function (e) {
    if (e.target.classList.contains('filters__tags')) {
      $('.filters__tags-list').toggleClass('show')
      return;
    }
    if ( e.target.classList.contains('filters__tags-label')
      || e.target.classList.contains('filters__tags-input')
      || e.target.classList.contains('filters__tags-label-text')) {
      return;
    }else {
      $('.filters__tags-list').removeClass('show')
    }
  })
})